import styled from "styled-components";

interface SideMenuItemStyleProps {
  $icon: boolean;
}

export const SideMenuItem = styled.li<SideMenuItemStyleProps>`
  display: grid;
  width: 100vw;
  height: 56px;
  padding: 16px 26px;
  background: ${(props) => props.theme.colors.white100};
  grid-template-columns: ${(props) =>
    props.$icon ? "20px auto 24px" : "auto 24px"};
  align-items: center;
  gap: 14px;

  svg:last-child {
    path {
      fill: ${(props) => props.theme.colors.black50};
    }
  }

  &:active {
    background: ${(props) => props.theme.colors.primary8};

    div {
      color: ${(props) => props.theme.colors.primary100};
      font-weight: 700;
    }

    svg {
      path {
        fill: ${(props) => props.theme.colors.primary100};
        fill-opacity: 1;
      }
    }
  }
`;

export const SideMenuTitle = styled.div`
  display: flex;
  color: ${(props) => props.theme.colors.black80};
  font-size: 1.4rem;
`;

export const AlarmBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
`;

export const NewAlarmSquare = styled.div`
  width: 16px;
  height: 16px;
  background-color: rgb(255, 0, 0);
  color: white;
  font-size: 8px;
  font-weight: 800;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  text-align: center;
  overflow: hidden;
`;
